import _extends from "@babel/runtime/helpers/extends";
import { setContext } from 'redux-saga/effects';
import { REQUESTS_CONFIG } from '../constants';
export var defaultRequestInstanceConfig = {
  driver: null,
  onRequest: null,
  onSuccess: null,
  onError: null,
  onAbort: null
};
export default function createRequestInstance(config) {
  var _setContext;

  return setContext((_setContext = {}, _setContext[REQUESTS_CONFIG] = _extends({}, defaultRequestInstanceConfig, {}, config), _setContext));
}